import { useState, useEffect } from "react";
import { ExpandedContent, Separator } from "../../Compartilhado/styles";
import { IItemHistorico } from "../../../../types";
import { DadosPendenciaMovida } from "./types";
import { processarDadosPendenciaMovida } from "./utils";
import BlocoAlteracoes from "./Blocos/BlocoAlteracoes/index";
import BlocoEmail from "../DemandaCriada/Blocos/BlocoEmail/index";
import LogsVazio from "../../Compartilhado/LogsVazio";
import api from "../../../../../../../services/api";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentPendenciaMovida({ item, onNavigateToFile }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosPendenciaMovida | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item.id) {
            setLoading(false);
            return;
        }

        const buscarDados = async () => {
            try {
                setLoading(true);
                const response = await api.get(`log-historico/${item.id}`);

                if (response.data.status === 'success') {
                    const logs = response.data.result || [];
                    const dadosProcessados = processarDadosPendenciaMovida(logs);
                    setDados(dadosProcessados);
                } else {
                    setDados({
                        alteracoes: [],
                        email: null
                    });
                }
            } catch (error: any) {
                console.error('Erro ao buscar dados do histórico:', error);
                setDados({
                    alteracoes: [],
                    email: null
                });
            } finally {
                setLoading(false);
            }
        };

        buscarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--c64748b)' }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    const temDadosValidos = dados.alteracoes.length > 0 || dados.email !== null;

    if (!temDadosValidos) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            {dados.alteracoes.length > 0 && <BlocoAlteracoes alteracoes={dados.alteracoes} idPendencia={dados.idPendencia} />}
            {dados.email && <BlocoEmail email={dados.email} />}
        </ExpandedContent>
    );
}

